import styled from '@emotion/styled';
import classNames from 'classnames';
import * as React from 'react';
import { DropzoneProps } from '../types';
import BodyDropzone from './body-dropzone';

export const Dropzone = React.forwardRef<HTMLDivElement, DropzoneProps>((props, ref) => {
  const { title, subtitle, buttonText, onButtonClick, children, rootProps, inputProps, ...rest } = props;

  return (
    <Container ref={ref} {...rootProps} {...rest} className={classNames(rootProps?.className, props.className)}>
      <input {...inputProps} />
      {children ?? <BodyDropzone title={title} subtitle={subtitle} buttonText={buttonText} onButtonClick={onButtonClick} />}
    </Container>
  );
});

export default Dropzone;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
  transition: border 0.5s ease;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.SurfaceCultured10};
  border-width: 1px;
  border-style: dashed;
  border-color: ${({ theme }) => theme.colors.SurfaceRomanSilver30};

  &.error {
    border-color: ${({ theme }) => theme.colors.error};
  }

  &.focused {
    border-color: ${({ theme }) => theme.colors.SurfaceRichBlack60};
  }

  &.active {
    border-color: ${({ theme }) => theme.colors.SurfaceRichBlack60};
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Disable interactions for all children while keeping container hoverable for cursor */
  &.disabled * {
    pointer-events: none;
  }
`;
